import { Injectable } from '@angular/core';
import {
    Sample,
    SampleSet,
    SampleSetMetaData,
    SampleData,
    SampleMeta
} from '../../samples/model/sample-management.model';
import {
    SampleSetMetaDTO,
    SampleSetDTO,
    SampleDataDTO,
    OrderDTO,
    SampleDTO,
    SampleMetaDTO
} from '../model/shared-dto.model';
import { SamplesMainData } from '../../samples/state/samples.reducer';

@Injectable({
    providedIn: 'root'
})
export class DTOFactoryService {

    fromSampleSet(sampleSet: SampleSet): SampleSetDTO {
        const dto: SampleSetDTO = {
            meta: this.fromSampleSetMeta(sampleSet.meta),
            samples: sampleSet.samples.map(sample => this.fromSample(sample))
        };
        return dto;
    }

    fromSamplesMainDataToOrderDTO({ meta, sampleData }: SamplesMainData): OrderDTO {
        const dto: SampleSetDTO = this.fromSampleSet({
            meta: meta,
            samples: sampleData
        });
        return { sampleSet: dto };
    }

    private fromSample(sample: Sample): SampleDTO {
        return {
            sampleData: this.fromSampleData(sample.sampleData),
            sampleMeta: this.fromSampleMeta(sample.sampleMeta)
        };
    }

    private fromSampleData(sampleData: SampleData): SampleDataDTO {
        const dto: Partial<SampleDataDTO> = {};
        (Object.keys(sampleData) as (keyof SampleData)[]).forEach(prop => dto[prop] = {
            value: sampleData[prop].value,
            oldValue: sampleData[prop].oldValue
        });
        return dto as SampleDataDTO;
    }

    private fromSampleMeta(sampleMeta: SampleMeta): SampleMetaDTO {
        return {
            nrl: sampleMeta.nrl,
            analysis: sampleMeta.analysis,
            urgency: sampleMeta.urgency
        };
    }

    private fromSampleSetMeta(meta: SampleSetMetaData): SampleSetMetaDTO {
        return {
            sender: meta.sender,
            fileName: meta.fileName,
            customerRefNumber: meta.customerRefNumber,
            signatureDate: meta.signatureDate,
            version: meta.version
        };
    }
}
